// extracted by mini-css-extract-plugin
export default {"root":"SimilarTrademarksHeader_root__YVNnK"};